<div class="background" [style.background-image]="backgroundImage | encodeURI: 'url'"></div>
